'use client';

import React from 'react';
import { ChipBase, type ChipBaseProps } from './ChipBase';
import { ChipEditable, type ChipEditableProps } from './ChipEditable';

export type { ChipEditingChangeReason } from './ChipEditable';

type ChipSharedPublicProps = Omit<ChipBaseProps, 'allowsRemoving'>;

type ChipStaticProps = ChipSharedPublicProps & {
    editable?: false;
};

type ChipEditablePublicProps = Omit<ChipEditableProps, 'allowsRemoving'> & {
    editable: true;
};

export type ChipProps = ChipStaticProps | ChipEditablePublicProps;

export const Chip = React.forwardRef<HTMLSpanElement, ChipProps>((props, ref) => {
    if (props.editable) {
        const { editable, ...editableProps } = props;
        return <ChipEditable ref={ref} {...editableProps} />;
    }

    const { editable, ...baseProps } = props;
    return <ChipBase ref={ref} {...baseProps} />;
});

Chip.displayName = 'RomaChip';
